export const CHECK_TYPES = {
  CONFIRMATION: "t",
  SENTINEL: "s",
  FATIGUE: "fatigueStatus",
  PAID: "paid",
  UNCONFIRMATION: "unt",
  UNSENTINEL: "uns",
  UNFATIGUE: "unfatigueStatus",
  UNPAID: "unpaid",
};
